import { FormControl, IconButton, MenuItem, Select, Tooltip } from "@mui/material";
import { useState } from "react";
import UpdateIcon from '@mui/icons-material/Update';

const SubProtocolCell = ({ value, row, onUpdate }) => {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleUpdate = (id) => {
        onUpdate(row._id, selectedValue);
        console.log(`Refresh row with id: ${id}`);
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <FormControl variant="outlined" size="small">
                <Select
                    value={selectedValue}
                    onChange={handleChange}
                >
                    {[0, 1, 2, 3, 4, 5, 6, 7].map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Tooltip title="Update Sub Protocol">
                <IconButton
                    color="secondary"
                    size="small"
                    style={{ marginRight: 8 }}
                    onClick={() => handleUpdate(row._id)}
                >
                    <UpdateIcon />
                </IconButton>
            </Tooltip>
        </div>
    );
};

export default SubProtocolCell;